<template>
  <div id="learn-station">
    <div class="station_content" v-if="stationState===2" ref="stationContent">
      <div class="station_card">
        <div class="station_title">质心教育课堂报告</div>
        <div class="userinfo-bck">
          <div class="userinfo-bck_img">
            <div class="userinfo">
              <div class="userinfo_list">
                <div class="user_img">
                  <img :src="userinfo.avatar" alt />
                </div>
                <div style="flex:1">
                  <div
                    class="user_name"
                    :style="userinfo.nameState===1?'color: rgba(51, 51, 51, 1);font-weight: 500;':'color: rgba(51, 51, 51, 0.6);font-weight: 400;'"
                  >
                    <span>{{userinfo.name}}</span>
                    <i v-if="userinfo.gender>0"
                      :class="userinfo.gender===1?'fa-zhixin fa-mars':'fa-zhixin fa-venus'"
                      :style="userinfo.gender===1?'color: #8790e8;':'color: #ff8493;'"
                    ></i>
                  </div>
                  <div class="user_phone">{{userinfo.phone}}</div>
                </div>
              </div>
              <div class="class_title">{{userinfo.title}}</div>
              <div class="class_subclass">
                <div class="subclass_num">第{{userinfo.subclassNum}}节</div>
                <div class="subclass_title">{{userinfo.subclass}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="station_card_bottom"></div>
      <div class="station_process_card">
        <div class="station_process_title">听课学习</div>
        <div class="station_process_info">
          <div class="process_info_title">学习进度：</div>
          <div class="process_info_num">
            <el-progress :percentage="processNum" :stroke-width="barProcessWidth" :color="processColor"></el-progress>
          </div>
        </div>
        <div class="process_info_text">{{processText}}</div>
      </div>
      <div class="answer_question">
        <div class="answer_question_title">课程互动</div>
        <div class="answer_question_sum">
          互动发言：
          <span>{{answerStation.speakSum}}</span>次
        </div>
        <div class="answer_question_content">题目作答：</div>
        <div class="answer_accuracy" v-if="answerStation.answerIsShow">
          <div class="answer_accuracy_total">
            <el-progress
              type="circle"
              :percentage="answerStation.accuracy"
              :stroke-width="annularProcessWidth"
              :color="processColor"
            ></el-progress>
            <div class="answer_accuracy_text">正确率</div>
            <div class="answer_accuracy_average">
              课堂平均正确率：
              <span>{{answerStation.averageRightRatio}}%</span>
            </div>
          </div>
          <div class="accuracy_info_list">
            <div class="answer_accuracy_info">
              <div class="answer_accuracy_info_title">正确</div>
              <div class="accuracy_info_process">
                <el-progress
                  :show-text="false"
                  :percentage="answerStation.rightRatio"
                  :stroke-width="barProcessWidth"
                  :color="processColor"
                ></el-progress>
              </div>
              <div class="accuracy_info_sum" ref="right_sum" :style="isShowWidth?'width:'+processMaxWidth:''">
                <span>{{answerStation.rightSum}}&nbsp;</span>题
              </div>
            </div>
            <div class="answer_accuracy_info">
              <div class="answer_accuracy_info_title">错误</div>
              <div class="accuracy_info_process">
                <el-progress
                  :show-text="false"
                  :percentage="answerStation.errorRatio"
                  :stroke-width="barProcessWidth"
                  :color="processColor"
                ></el-progress>
              </div>
              <div class="accuracy_info_sum" ref="error_sum"  :style="isShowWidth?'width:'+processMaxWidth:''">
                <span>{{answerStation.errorSum}}&nbsp;</span>题
              </div>
            </div>
            <div class="answer_accuracy_info">
              <div class="answer_accuracy_info_title">未答</div>
              <div class="accuracy_info_process">
                <el-progress
                  :show-text="false"
                  :percentage="answerStation.noAnswerRatio"
                  :stroke-width="barProcessWidth"
                  :color="processColor"
                ></el-progress>
              </div>
              <div class="accuracy_info_sum" ref="noAnswer_sum"  :style="isShowWidth?'width:'+processMaxWidth:''">
                <span>{{answerStation.noAnswerSum}}&nbsp;</span>题
              </div>
            </div>
          </div>
        </div>
        <div class="no_answer_accuracy" v-else>
          <img :src="emptypic" alt />
          <div>本节课无选择题</div>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="notregistered_content" v-else-if="stationState===1">
      <div class="no_registered_img">
        <img :src="generatingReports" alt />
      </div>
      <div class="no_registered_phone">下课半小时后生成课堂报告，请稍作等待</div>
      <div class="no_registered_phone">
        报告生成时间：
        <span>{{reportDate}}</span>
      </div>
      <div class="switch_account">
        <el-button @click="refresh" v-preventReClick>点击刷新</el-button>
      </div>
    </div>
    <div class="notregistered_content" v-else>
      <div class="no_registered_img">
        <img :src="notRegistered" alt />
      </div>
      <div class="no_registered_phone">当前账号 {{userinfo.phone}} 未报名此课程</div>
      <div class="switch_account">
        <el-button @click="exitLogin">切换账号</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import api from '@/api'
import { mapActions } from 'vuex'
import filters from '@/utils/filters'
export default {
  data () {
    return {
      processColor: 'rgba(0, 199, 191, 1)',
      // manpic: require('@/assets/img/learning/panda.jpg'),
      emptypic: require('@/assets/img/learning/empty.svg'),
      notRegistered: require('@/assets/img/learning/notRegistered.svg'),
      generatingReports: require('@/assets/img/learning/generating_reports.svg'),
      annularProcessWidth: 10,
      barProcessWidth: 10,
      processNum: 0,
      processText: '',
      userinfo: {
        avatar: '',
        name: '',
        nameState: 0,
        phone: '',
        title: '',
        subclass: '',
        subclassNum: 0,
        gender: 0
      },
      reportDate: '',
      answerStation: {
        answerIsShow: -1,
        speakSum: 0,
        accuracy: 0,
        rightSum: 0,
        rightRatio: 0,
        errorSum: 0,
        errorRatio: 0,
        noAnswerSum: 0,
        noAnswerRatio: 0,
        averageRightRatio: 0
      },
      processMaxWidth: '',
      isShowWidth: false,
      stationState: 1,
      loginUrl: ''
    }
  },
  computed: {
    // ...mapState({
    //   isLogin: (state) => state.user.isLogin,
    //   userInfo: (state) => state.user.userInfo
    // })
  },
  methods: {
    ...mapActions(['logout']),
    exitLogin () {
      this.logout().then((res) => {
        if (res.data.code === 1) {
          this.$message.success('账号退出成功')
          this.tologin()
        }
      })
      this.zhuGeEventTrack(this.zhugeEvents.USER_ACTION.LOG_OUT_CLICK)
    },
    tologin () {
      window.location.href =
        process.env.VUE_APP_PASSPORT_URL +
        '/Login/?return_url=' +
        process.env.VUE_APP_DOMAIN +
        '/learningSituation/' +
        this.$route.params.classId +
        '/' +
        this.$route.params.subclassId
    },
    getStudyStation () {
      var data = {
        subclass_id: this.$route.params.subclassId,
        class_id: this.$route.params.classId
      }
      api
        .studyStation(data)
        .then((r) => {
          if (r.data.code === 60888) {
            this.tologin()
          } else if (r.data.code === 65018) {
            const item = r.data.data
            this.stationState = 0
            this.userinfo.phone = r.data.data.user.mobile ? r.data.data.user.mobile : ''
            this.zhuGeEventTrack(this.zhugeEvents.LEARING_SITUATION.LEARING_SITUATION_LOADING, [
              '否',
              '未生成',
              item.live_class.class_subject
                ? item.live_class.class_subject
                : '',
              item.live_class.subclass_subject
                ? item.live_class.subclass_subject
                : '',
              '-'
            ])
          } else if (r.data.code === 65019) {
            const item = r.data.data
            this.stationState = 1
            this.reportDate = filters.formatMDHMS(Number(r.data.data.report_at))
            // const nowTime = parseInt(new Date().getTime() / 1000)
            // this.reportDate = filters.formatMDHMS(nowTime)
            this.zhuGeEventTrack(this.zhugeEvents.LEARING_SITUATION.LEARING_SITUATION_LOADING, [
              '是',
              '未生成',
              item.live_class.class_subject
                ? item.live_class.class_subject
                : '',
              item.live_class.subclass_subject
                ? item.live_class.subclass_subject
                : '',
              '-'
            ])
          } else if (r.data.code === 1) {
            this.stationState = 2
            const item = r.data.data
            this.userinfo.avatar = item.user.avatar
            this.userinfo.name = item.user.real_name
              ? item.user.real_name
              : '未填写真实姓名'
            this.userinfo.nameState = item.user.real_name ? 1 : 0
            this.userinfo.phone = item.user.mobile ? item.user.mobile : ''
            this.userinfo.title = item.live_class.class_subject
              ? item.live_class.class_subject
              : ''
            this.userinfo.subclass = item.live_class.subclass_subject
              ? item.live_class.subclass_subject
              : ''
            this.userinfo.subclassNum = item.live_class.sub_index
              ? item.live_class.sub_index
              : 0
            this.userinfo.gender = item.user.gender ? item.user.gender === 1 ? 1 : 2 : 0
            this.answerStation.speakSum = item.interact && item.interact.im_message_count ? item.interact.im_message_count : 0
            if (item.interact && item.interact.question) {
              this.answerStation.answerIsShow = 1
              this.answerStation.accuracy = item.interact.question.right_ratio ? item.interact.question.right_ratio : 0
              this.answerStation.rightSum = item.interact.question.right_count ? item.interact.question.right_count : 0
              this.answerStation.errorSum = item.interact.question.wrong_count ? item.interact.question.wrong_count : 0
              this.answerStation.noAnswerSum = item.interact.question.no_submit_count ? item.interact.question.no_submit_count : 0
              this.answerStation.averageRightRatio = item.interact.question.average_right_ratio ? item.interact.question.average_right_ratio : 0
              const questionSum = item.interact.question.right_count + item.interact.question.wrong_count + item.interact.question.no_submit_count
              this.answerStation.rightRatio = this.answerStation.rightSum / questionSum * 100
              this.answerStation.errorRatio = this.answerStation.errorSum / questionSum * 100
              this.answerStation.noAnswerRatio = this.answerStation.noAnswerSum / questionSum * 100
            } else {
              this.answerStation.answerIsShow = 0
            }
            this.processNum = item.class_progress && item.class_progress.progress ? item.class_progress.progress : 0
            if (this.processNum <= 20) {
              this.processText = '据说，观看直播的学习效果会更好'
            } else if (this.processNum > 20 && this.processNum <= 60) {
              this.processText = '一分耕耘一分收获，为了掌握知识，请督促孩子及时观看课程回放'
            } else if (this.processNum > 60 && this.processNum <= 90) {
              this.processText = '知识源于积累，如果孩子能坚持听完课程就更棒啦'
            } else {
              this.processText = '积跬步以至千里，表扬下努力学习的孩子吧'
            }
            this.$nextTick(() => {
              var maxWidth = Math.max(this.$refs.right_sum.clientWidth, this.$refs.error_sum.clientWidth, this.$refs.noAnswer_sum.clientWidth)
              this.processMaxWidth = maxWidth + 1 + 'px'
              if (this.$refs.stationContent.clientWidth < 600) {
                this.barProcessWidth = 8
              }
            })
            this.zhuGeEventTrack(this.zhugeEvents.LEARING_SITUATION.LEARING_SITUATION_LOADING, [
              '是',
              '已生成',
              this.userinfo.title,
              this.userinfo.subclass,
              this.processNum
            ])
          } else {
          }
        })
        .catch((e) => {
          console.log('e: ', e)
        })
    },
    refresh () {
      this.getStudyStation()
    }
  },
  created () {
    this.getStudyStation()
  },
  mounted () {
    $('#footer').hide()
    $('.box-active1').hide()
    $('.banner').hide()
    $('aside').hide()
    this.$nextTick(() => {
      $('.el-main').css('background', 'white')
    })
  },
  watch: {
    processMaxWidth: {
      handler: function () {
        this.$nextTick(() => {
          this.isShowWidth = true
        })
      }
    }
  },
  beforeDestroy () {
    $('.el-main').css('background', '')
    window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
  }
}
</script>
<style scoped>
</style>
<style lang="scss" scoped>
#learn-station {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #ffffff;
  z-index: 20;
  left: 0;
  top: 0;
  overflow-y: scroll;
  .notregistered_content {
    max-width: 600px;
    margin: auto;
    box-sizing: border-box;
    padding-bottom: 20px;
    background: rgba(255, 255, 255, 1);
    text-align: center;
    box-sizing: border-box;
    padding-top: 106px;
    .no_registered_phone {
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin: 32px 0px 24px 0px;
      span {
        color: rgba(0, 199, 191, 1);
      }
    }
  }
  .station_content {
    max-width: 600px;
    margin: auto;
    box-sizing: border-box;
    padding-bottom: 20px;
    background: rgba(245, 245, 245, 1);
    height: 100%;
    .station_card {
      background: url("~@/assets/img/learning/bck3.svg") no-repeat;
      background-size: cover;
      // height: 224px;
      box-sizing: border-box;
      padding: 15px 0px 0px 0px;
      .station_title {
        text-align: center;
        font-size: 1.8em;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
      .userinfo-bck {
        width: 94.66%;
        background-color: #ffffff;
        box-shadow: 0px 4px 9px 0px rgba(0, 160, 153, 1);
        border-radius: 8px;
        margin: auto;
        height: 16.3em;
        // height: 163px;
        margin-top: 1.6em;
        .userinfo-bck_img {
          background: url("~@/assets/img/learning/ball.svg") no-repeat;
          background-size: 100% 100%;
          padding-bottom: 15px;
          .userinfo {
            box-sizing: border-box;
            padding: 1.3em 1.4em 0px 1.4em;
            // height: 16.3em;
            //   height: 163px;
            .class_title {
              font-size: 1.8em;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              width: 86.87%;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              -webkit-text-overflow: ellipsis;
              -moz-text-overflow: ellipsis;
              white-space: nowrap;
            }
            .class_subclass {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 0.4em;
              .subclass_num {
                background: rgba(0, 199, 191, 0.1);
                border-radius: 2px;
                font-size: 1.2em;
                font-weight: 400;
                color: rgba(0, 199, 191, 1);
                //   margin-right: 0.8rem;
                box-sizing: border-box;
                min-width: 40px;
                text-align: center;
                padding :2px 4px 2px 4px
              }
              .subclass_title {
                font-size: 1.4em;
                line-height: 1.4em;
                font-weight: 400;
                color: rgba(51, 51, 51, 0.6);
                width: 86.87%;
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                -webkit-text-overflow: ellipsis;
                -moz-text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .userinfo_list {
              display: flex;
              // margin-bottom: 1.7em;
              align-items: center;
              .user_img {
                width: 4em;
                height: 4em;
                box-shadow: 0px 2px 10px 0px rgba(169, 174, 189, 0.18);
                border-radius: 50%;
                margin-right: 1.2em;
                img {
                  width: 4em;
                  height: 4em;
                  border-radius: 50%;
                }
              }
              .user_name {
                margin-top: 8px;
                font-size: 1.4em;
                display: flex;
                align-items: center;
                span {
                  display: inline-block;
                  max-width: 36.87%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  -o-text-overflow: ellipsis;
                  -webkit-text-overflow: ellipsis;
                  -moz-text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
              .user_phone {
                margin-top: 0.4em;
                font-size: 1.2em;
                font-weight: 400;
                color: rgba(51, 51, 51, 0.4);
                line-height: 1.2em;
              }
            }
          }
        }
      }
    }
  }
  .station_card_bottom {
    background: url("~@/assets/img/learning/card_bottom.svg") no-repeat;
    height: 80px;
    // margin-top: -34px;
    background-size: cover;
  }
  .answer_question {
    width: 94.66%;
    background-color: #ffffff;
    border-radius: 8px;
    margin: auto;
    padding: 16px 32px 14px 16px;
    margin-top: 8px;
    .answer_question_title {
      font-size: 1.6em;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .answer_question_sum {
      font-size: 1.4em;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.6);
      margin-top: 16px;
      span {
        font-size: 1em;
        font-weight: 500;
        color: rgba(0, 199, 191, 1);
        margin-right: 5px;
      }
    }
    .answer_accuracy {
      .answer_accuracy_total {
        text-align: center;
        margin-right: 30px;
        .answer_accuracy_average {
          font-size: 1.2em;
          font-weight: 400;
          color: rgba(51, 51, 51, 0.6);
          margin-top: 16px;
          span {
            color: rgba(0, 199, 191, 1);
          }
        }
      }
    }
    .no_answer_accuracy {
      text-align: center;
      font-size: 1.2em;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.4);
      padding-bottom: 20px;
      img {
        margin-bottom: 10px;
      }
    }
    .answer_question_content {
      font-size: 1.4em;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.6);
      margin: 16px 0px 24px 0px;
    }
    .answer_accuracy {
      display: flex;
      .answer_accuracy_text {
        text-align: center;
        font-size: 1.2em;
        font-weight: 400;
        color: rgba(0, 199, 191, 1);
        margin-top: 12px;
      }
      .accuracy_info_list {
        flex: 1;
        .answer_accuracy_info {
          display: flex;
          align-items: center;
          margin-bottom: 18px;
          .accuracy_info_process {
            margin-left: 6px;
            flex: 1;
          }
          .answer_accuracy_info_title {
            font-size: 1.2em;
            font-weight: 400;
            color: rgba(51, 51, 51, 0.6);
          }
          .accuracy_info_sum {
            margin-left: 7px;
            text-align: right;
            font-size: 1.2em;
            font-weight:400;
            color:rgba(51,51,51,0.6);
            span {
              font-size: 1em;
              font-weight: 500;
              color: rgba(0, 199, 191, 1);
            }
          }
        }
      }
    }
  }
  .station_process_card {
    width: 94.66%;
    background-color: #ffffff;
    border-radius: 8px;
    margin: auto;
    margin-top: -44px;
    padding: 16px 16px 14px 16px;
    .station_process_title {
      font-size: 1.6em;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      margin-right: 8px;
    }
    .station_process_info {
      display: flex;
      font-size: 1.4em;
      margin-top: 16px;
      align-items: center;
      .process_info_title {
        font-weight: 400;
        // font-size: 1.4em;
        color: rgba(51, 51, 51, 0.6);
        margin-right: 8px;
      }
      .process_info_num {
        flex: 1;
      }
    }
    .process_info_text {
      background: rgba(0, 199, 191, 0.06);
      font-size: 1.4em;
      font-weight: 400;
      color: rgba(0, 199, 191, 1);
      box-sizing: border-box;
      padding: 3px 6px 3px 6px;
      border-radius: 4px;
      margin-top: 13px;
      display: inline-block;
    }
  }
}
@media (min-width: 300px) {
  #learn-station {
    font-size: 10px;
    .userinfo_list {
      margin-bottom: 19px;
    }
    .station_card_bottom {
      margin-top: -34px;
    }
    .station_process_card {
      margin-top: -44px;
    }
    .station_card {
      height: 224px;
    }
  }
}
@media (min-width: 411px) {
  #learn-station {
    font-size: 11.04px;
    .station_card_bottom {
      margin-top: -24px;
    }
    .userinfo_list {
      margin-bottom: 27px;
    }
  }
}
@media (min-width: 600px) {
  #learn-station {
    font-size: 16px;
    .userinfo_list {
      margin-bottom: 46px;
    }
    // .subclass_num {
    //   padding: 2px 4px 2px 4px;
    // }
    .station_card_bottom {
      margin-top: -64px;
    }
    .station_card {
      height: 358.4px;
    }
    .station_process_card {
      margin-top: -24px;
    }
  }
}
</style>
<style  scoped>
#learn-station .station_content .station_process_card >>> .el-progress__text {
  color: rgba(0, 199, 191, 1);
  /* margin-left: 12px; */
  font-weight: 500;
  font-size: 1em !important;
}
#learn-station .station_content >>> .el-progress-bar__outer {
background: rgba(247,247,247,1);
}
#learn-station .station_content >>> svg path:first-child {
stroke: rgba(247,247,247,1);
}
@media (min-width: 300px) {
  #learn-station .station_content .answer_question >>> .el-progress-circle {
    width: 87px !important;
    height: 87px !important;
  }
  #learn-station
  .station_content
  .answer_question
  .answer_accuracy_total
  >>> .el-progress__text {
  font-size: 24px !important;
  font-weight: 400;
  color: rgba(0, 199, 191, 1);
}
}
@media (min-width: 600px) {
  #learn-station .station_content .answer_question >>> .el-progress-circle {
    width: 126px !important;
    height: 126px !important;
  }
  #learn-station
  .station_content
  .answer_question
  .answer_accuracy_total
  >>> .el-progress__text {
  font-size: 28px !important;
  font-weight: 400;
  color: rgba(0, 199, 191, 1);
}
}

#learn-station .switch_account >>> .el-button {
  width: 120px;
  height: 42px;
  background: rgba(0, 199, 191, 1);
  border-radius: 6px;
  color: white;
}
</style>
